import {
  type AttributeDetailOptionDTO,
  type AttributeOptionDTO,
  parseOptionsDTO,
  parseProductOptionDTO,
  type ProductOptionDTO
} from './option-dtos.js'
import { parseStepFilterDTO, StepFilterDTO } from './step-filter-dto.js'
import { createValidate } from 'typia'
import { validateGuard } from 'components/shared/parsing/parsing.js'
import { StepSelection } from './step-selection-data.js'

import { StepType } from './step-type.js'

export type IStepDataDTO = {
  id: number
  name: string
  step_index: number
  type: StepType
  filters: unknown[]
  component: string
  content: {
    additional_texts: Record<string, { name: string; description: string }>
  }
  selected: StepSelection
  attribute: number | null
  required: boolean
  optional: boolean
  show_result: boolean
  all_options: boolean
  double_set: boolean
  auto_select_all: boolean
  auto_select: boolean
  sub_select: boolean
  step_group: string | null
  set1: number | null
  set2: number | null
  attributes1: number[]
  attributes2: number[]
  options1?: unknown[]
  options2?: unknown[]
  selected_filters?: Record<string, number>
}

export class StepDataDTO {
  id: number
  name: string
  stepIndex: number
  type: StepType
  filters: StepFilterDTO[]
  component: string
  content: {
    additionalTexts: Record<string, { name: string; description: string }>
  }
  selected: StepSelection
  attribute: number | null
  required: boolean
  optional: boolean
  showResult: boolean
  allOptions: boolean
  doubleSet: boolean
  autoSelectAll: boolean
  autoSelect: boolean
  subSelect: boolean
  stepGroup: string | null
  set1: number | null
  set2: number | null
  attributes1: number[]
  attributes2: number[]
  options1: (AttributeOptionDTO | ProductOptionDTO | AttributeDetailOptionDTO)[] | undefined
  options2: ProductOptionDTO[] | undefined
  selectedFilters: Record<string, number> | undefined

  constructor(data: IStepDataDTO) {
    this.id = data.id
    this.name = data.name
    this.stepIndex = data.step_index
    this.type = data.type
    this.filters = data.filters.map(parseStepFilterDTO)
    this.component = data.component
    this.content = {
      additionalTexts: data.content.additional_texts,
    }
    this.selected = data.selected
    this.attribute = data.attribute
    this.required = data.required
    this.optional = data.optional
    this.showResult = data.show_result
    this.allOptions = data.all_options
    this.doubleSet = data.double_set
    this.autoSelectAll = data.auto_select_all
    this.autoSelect = data.auto_select
    this.subSelect = data.sub_select
    this.stepGroup = data.step_group
    this.set1 = data.set1
    this.set2 = data.set2
    this.attributes1 = data.attributes1
    this.attributes2 = data.attributes2
    this.options1 = data.options1?.map(option => parseOptionsDTO(option, data.type))
    this.options2 = data.options2?.map(parseProductOptionDTO)
    this.selectedFilters = data.selected_filters
  }
}

const validateStepDataDTO = createValidate<IStepDataDTO>()

export const parseStepDataDTO = (data: unknown): StepDataDTO => {
  validateGuard(validateStepDataDTO, data, 'StepDataDTO')
  return new StepDataDTO(data)
}
